// SCACTypeFormDialog.js

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Box,
} from "@mui/material";
import loaderGif from "./../Assests/loader.gif";

const SCACTypeFormDialog = ({ open, handleClose, handleSave, initialData }) => {
  const initialFormData = {
    scacTypeNo: "",
    scac_type: "",
    description: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState ({});
  const [isSaving, setIsSaving] = useState(false);


  // Update formData whenever initialData changes or reset it if initialData is null (adding a new record)
  useEffect(() => {
    // Reset the field errors every time the dialog is opened
  setFieldErrors({});
   if (initialData) {
     setFormData(initialData);
   } else {
     setFormData(initialFormData);
   }
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    // SCAC Code validation
    if (!formData.scac_type) {
      errors.scac_type = "SCAC Type is required";
    } else if (typeof formData.scac_type !== "string") {
      errors.scac_type = "SCAC Type must be a string";
    }

    // SCAC Name validation
    if (!formData.description) {
      errors.description = " Description is required";
    } else if (typeof formData.description !== "string") {
      errors.description = "Description must be a string";
    }
    setFieldErrors(errors);

    // Return true if no errors
    return Object.keys(errors).length === 0;
  };

  const onSave = async() => {
    if (validateForm(formData)) {
      setIsSaving(true);
      try{
        
        await handleSave(formData);
        handleClose();
      }catch(error){
        console.error("Error saving SCAC Type:", error);
      }finally{
       
        setIsSaving(false);
      }
     
    }
  };

     

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle className="modal-header">
        {initialData ? "Update SCAC Type" : "Add New SCAC Type"}
      </DialogTitle>
      {isSaving && (
        <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
      )}
      <DialogContent>
        <TextField
          margin="dense"
          name="scac_type" // Updated to match payload key
          label="SCAC Type"
          fullWidth
          variant="outlined"
          value={formData.scac_type}
          onChange={handleChange}
          disabled={!!initialData}  // Disable if initialData is present (update mode)
        />
         {fieldErrors.scac_type &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.scac_type}
          </div>}
        <TextField
          margin="dense"
          name="description" // Unchanged, as it matches the payload key
          label="Description"
          fullWidth
          variant="outlined"
          value={formData.description}
          onChange={handleChange}
        />
        {fieldErrors.description &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.description}
          </div>}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          {initialData ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SCACTypeFormDialog;









